export default "__VITE_ASSET__D0_FDIOH__"